import { Component, OnInit, Input } from '@angular/core';
import { CmsService } from 'src/app/services/api/cms.service';
import { CollapsibleService } from 'src/app/services/collapsible.service';
import { WinService } from 'src/app/services/win.service';

@Component({
  selector: 'app-page-block-common',
  templateUrl: './page-block-common.component.html',
  styleUrls: ['./page-block-common.component.scss']
})
export class PageBlockCommonComponent implements OnInit {

	@Input() blockId = null;
	@Input() bgColor: string = 'bg-yellow';

	elId:any = '';
	block:any = null;
	isCollapsible:boolean = false;


	constructor(
		public cms: CmsService,
		public winService: WinService,
		public collapsibleService: CollapsibleService
	) { }

	ngOnInit(): void {
		this.cms.getBlock(this.blockId, true, false).then(block => {
			this.block = block;
			this.elId = this.block.identifier;
			if(this.block.identifier === this.block.title + '-collapsible'){
				this.isCollapsible = true;
			}
		});
	}

	setCollapsible(){
		this.collapsibleService.setCollapsible(this.elId);
	}

}
